module.exports = __webpack_public_path__ + "img/top2.98d878ec.png";